export const DEFAULT_REDIRECT_STRATEGY = 'redirect';
